import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuTextWithInfoOption} from '@Components/contextual-menu/components/contextual-menu-text-with-info-option';
import {onOpenResizeModal} from '@Components/poster-editor/library/poster-editor-open-modals';
import {useAppSelector} from '@/hooks';
import styles from './page-type-option.module.scss';

export function PageTypeOption(): ReactElement<any> | null {
  const posterType = useAppSelector((state) => {
    return state.posterEditor.posterObject?.type.displayName;
  });

  const posterSize = useAppSelector((state) => {
    return state.posterEditor.posterObject?.type.description;
  });

  const posterUnits = useAppSelector((state) => {
    return state.posterEditor.posterObject?.units;
  });

  const posterWidth = useAppSelector((state) => {
    return state.posterEditor.posterObject?.userWidth;
  });

  const posterHeight = useAppSelector((state) => {
    return state.posterEditor.posterObject?.userHeight;
  });

  const onClickHandler = (): void => {
    onOpenResizeModal();
  };

  const showCustomSize = window.posterEditor?.whiteboard?.type.isCustomSize() && window.posterEditor?.whiteboard?.type.idUserPosterType === 0;
  let subText = '';
  if (showCustomSize) {
    if (posterWidth && posterUnits && posterHeight) {
      subText = `${posterWidth}${posterUnits} x ${posterHeight}${posterUnits}`;
    }
  } else if (posterSize) {
    subText = posterSize;
  }

  return (
    <ContextualMenuTextWithInfoOption
      infoContainerClassName={styles.container}
      id="design-page-option"
      label={window.i18next.t('pmwjs_size')}
      text={posterType ?? ''}
      subText={subText ?? ''}
      onClick={onClickHandler}
    />
  );
}
